﻿import { UseHttpOptions, getToken } from './extensions'

export interface StatusCheckBase {
  table?: string
  id?: string
  ticks?: number
}

export const waitForChange = async (d: StatusCheckBase | StatusCheckBase[], baseUrl: string, controller: AbortController, options?: UseHttpOptions) => {
  let arr: StatusCheckBase[];

  if (Array.isArray(d)) {
    arr = d;
  }
  else {
    arr = [d];
  }

  if (!baseUrl || baseUrl[baseUrl.length - 1] != '/')
    baseUrl += '/';

  const headers: any = {
    'Content-Type': 'application/json'
  };
  if (options) {
    let token = await getToken(options.msalClient, options.scopes);
    headers.Authorization = `Bearer ${token}`;
  }

  for (let i = 0; i < 10; i++) {

    let res = await fetch(baseUrl + 'dataversedb', {
      method: "POST",
      body: JSON.stringify(arr),
      headers,
      signal: controller.signal
    });

    let data = await res.json() as StatusCheckBase[];
    if (!data || data.length == 0) {
      break;
    }

    await new Promise((resolve) => setTimeout(resolve, 3000));
  }
}